import React from "react";
import { LanguageCardProps } from "../../types/screensTypes";
import styles from "./LanguageCard.module.css";

export const LanguageCard: React.FC<LanguageCardProps> = ({ language, onRemoveLanguage }) => {
    return (
        <div className={styles.chip} key={language}>
            <span className={styles.label}>{language}</span>
            <button
                type="button"
                className={styles.remove}
                onClick={() => onRemoveLanguage(language)}
                aria-label="Remove"
            >
                &times;
            </button>
        </div>
    );
};
